<template>
  <div class="cooperative-platform page-content">
    <section class="module__header">
      <h2 class="module__header__title">合作网络平台</h2>
      <p class="module__header__subtitle">Collaborative network platform</p>
    </section>
    <section class="table-list">
      <table class="align-left">
        <colgroup>
          <col />
          <col style="width: 670px" />
        </colgroup>
        <thead>
          <tr>
            <th>类型</th>
            <th>平台</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in platforms" :key="index">
            <td>{{ item.type || "-" }}</td>
            <td>{{ item.name }}</td>
          </tr>
        </tbody>
      </table>
    </section>
    <section class="card-list">
      <section class="card" v-for="(item, index) in platforms" :key="index">
        <section class="description">
          <span class="label">类型</span>
          <section class="value">{{ item.type || "-" }}</section>
        </section>
        <section class="description">
          <span class="label">平台</span>
          <section class="value">{{ item.name }}</section>
        </section>
      </section>
    </section>
  </div>
</template>

<script>
import { get } from "lodash";
export default {
  name: "cooperative-platform",
  data() {
    return {
      platforms: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("/base/official-site/anonymous/pcPartnerList?pageSize=1000")
        .then((res) => {
          const records = get(res, "data.records");
          if (Array.isArray(records)) {
            this.platforms = records;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style lang="less"></style>
